export default __webpack_public_path__ + "static/media/big_board_logo.33d9550b.png";